function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ACCESS_TYPE_FLOW } from '@/js/constants';
import TableauUserAccessService from '@/apps/data-platform/services/visualization/tableauRol';
import tasks from '@/js/tasks';
export default {
  name: 'FormSelectTableauUser',
  props: {
    userTableauOptions: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return Object;
      }
    },
    tableauType: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: function data() {
    return {
      userTableau: null,
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      MODAL_WORKBOOK_METADATA_ACCESS: 'modalWorkbookMetadataAccess',
      MODAL_DATASOURCE_METADATA_ACCESS: 'modalDatasourceMetadataAccess'
    };
  },
  methods: {
    openModalSelectTableauUser: function openModalSelectTableauUser(item) {
      var _this = this;
      this.item = item;
      this.currentModalView = this.MODAL_SELECT_USER_TABLEAU;
      this.userTableau = null;
      TableauUserAccessService.getUserTableauByEmail().then(function (response) {
        _this.userTableauOptions = [{
          value: null,
          text: 'Please select an user'
        }].concat(response.data);
        _this.$bvModal.show(_this.MODAL_SELECT_USER_TABLEAU);
      });
    },
    onSubmit: function onSubmit(event) {
      var _this2 = this;
      event.preventDefault();
      if (!this.userTableau) {
        tasks.toast.error('Seleccione un usuario');
        // this.$toast.warning("Seleccione un usuario")
        return;
      }
      var params = _objectSpread(_objectSpread({}, this.item), {}, {
        user_tableau: this.userTableau
      });
      TableauUserAccessService.checkUserHasAccess(params).then(function (response) {
        if (response.data) {
          _this2.dangerMessage = " ".concat(_this2.userTableau, " has already access to the workbook: ").concat(_this2.item.object_name);
          _this2.dismissCountDown = _this2.dismissSecs;
        } else {
          _this2.$emit('onCloseModal');
          var tableauType = _this2.tableauType === 'workbook' ? _this2.MODAL_WORKBOOK_METADATA_ACCESS : _this2.MODAL_DATASOURCE_METADATA_ACCESS;
          _this2.$emit('openMetaDataTableau', {
            id_inca: _this2.item.id,
            dominio: _this2.item.domain
          }, ACCESS_TYPE_FLOW.ACCESS, tableauType, _this2.userTableau);
        }
      });
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onCloseModal: function onCloseModal() {
      this.$emit('onCloseModal');
    }
  }
};